<template>
  <div id="ProductPurchaseColorMgmt" style="margin: 0px auto">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
        <el-breadcrumb-item>颜色管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main-box">
      <el-table ref="table" :data="dataList" stripe size="mini" :highlight-current-row="true">
        <el-table-column prop="productName" label="产品名称" width="80px" align="center" :key="1100"> </el-table-column>
        <el-table-column label="颜色类型" width="100px" align="right" :key="1110">
          <template slot-scope="scope">
            <div>亚马逊颜色</div>
            <div class="line-two">采购颜色</div>
            <div class="line-two">已使用采购颜色</div>
          </template>
        </el-table-column>
        <el-table-column label="颜色1" width="80px" align="center" :key="110">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 0">
              <div>{{ getColorLabel(scope.row.colorList[0]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[0]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[0])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[0]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色2" width="80px" align="center" :key="111">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 1">
              <div>{{ getColorLabel(scope.row.colorList[1]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[1]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[1])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[1]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色3" width="80px" align="center" :key="112">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 2">
              <div>{{ getColorLabel(scope.row.colorList[2]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[2]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[2])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[2]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色4" width="80px" align="center" :key="113">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 3">
              <div>{{ getColorLabel(scope.row.colorList[3]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[3]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[3])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[3]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色5" width="80px" align="center" :key="114">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 4">
              <div>{{ getColorLabel(scope.row.colorList[4]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[4]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[4])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[4]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色6" width="80px" align="center" :key="115">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 5">
              <div>{{ getColorLabel(scope.row.colorList[5]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[5]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[5])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[5]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色7" width="80px" align="center" :key="116">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 6">
              <div>{{ getColorLabel(scope.row.colorList[6]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[6]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[6])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[6]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色8" width="80px" align="center" :key="117">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 7">
              <div>{{ getColorLabel(scope.row.colorList[7]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[7]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[7])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[7]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色9" width="80px" align="center" :key="118">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 8">
              <div>{{ getColorLabel(scope.row.colorList[8]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[8]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[8])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[8]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色10" width="80px" align="center" :key="119">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 9">
              <div>{{ getColorLabel(scope.row.colorList[9]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[9]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[9])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[9]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色11" width="80px" align="center" :key="120">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 10">
              <div>{{ getColorLabel(scope.row.colorList[10]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[10]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[10])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[10]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色12" width="80px" align="center" :key="121">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 11">
              <div>{{ getColorLabel(scope.row.colorList[11]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[11]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[11])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[11]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色13" width="80px" align="center" :key="122">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 12">
              <div>{{ getColorLabel(scope.row.colorList[12]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[12]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[12])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[12]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色14" width="80px" align="center" :key="123">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 13">
              <div>{{ getColorLabel(scope.row.colorList[13]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[13]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[13])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[13]) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="颜色15" width="80px" align="center" :key="124">
          <template slot-scope="scope">
            <div v-if="scope.row.colorList.length > 14">
              <div>{{ getColorLabel(scope.row.colorList[14]) }}</div>
              <div class="line-two">{{ getParentPurchaseColorLabel(scope.row.productType, scope.row.colorList[14]) }}</div>
              <div class="line-two" @click="onPurchaseColorClick(scope.row.productType, scope.row.colorList[14])">{{ getPurchaseColorLabel(scope.row.productType, scope.row.colorList[14]) }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { activeProducts, colors, models } from "../../utils/constant.js";

export default {
  data() {
    return {
      productList: activeProducts,
      colorList: colors,
      planList: [],
      params: {},
      screenHeight: document.body.clientHeight - 64 - 132 - 68,
      allPurchases: [],
    };
  },
  mounted() {
    this.getData();
    // this.getAllPurchases();

    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 132 - 68;
    },
    detail(row) {
      window.open("/client/outStockMgmt/detail?planId=" + row.planId);
    },
    // getAllProducts() {
    //   requestModules.fetchProducts({ beginIndex: 0, pageSize: 10000 }).then(res => {
    //     this.allProducts = res.ldata;
    //   });
    // },
    getAllPurchases() {
      requestModules.fetchPurchases({ beginIndex: 0, pageSize: 10000 }).then(res => {
        this.allPurchases = res.ldata;
      });
    },
    onPurchaseColorClick(productType, productColor) {
      let colorLabel = this.getPurchaseColorLabel(productType, productColor);

      this.$prompt("请输入采购颜色", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: colorLabel,
      })
        .then(({ value }) => {
          let parentProduct = this.productList.find(pd => pd.productType == productType);
          let purchaseColors = parentProduct.purchaseColors ? JSON.parse(parentProduct.purchaseColors) : [];
          let colorObj = purchaseColors.find(pc => pc.productColor == productColor);
          if (colorObj) {
            colorObj.purchaseColorName = value;
          } else {
            purchaseColors.push({
              productColor,
              purchaseColorName: value,
            });
          }
          parentProduct.purchaseColors = JSON.stringify(purchaseColors);
          parentProduct.checkModels = Array.isArray(parentProduct.checkModels) ? JSON.stringify(parentProduct.checkModels) : parentProduct.checkModels;
          parentProduct.checkColors = Array.isArray(parentProduct.checkColors) ? JSON.stringify(parentProduct.checkColors) : parentProduct.checkColors;

          requestModules
            .updateParentProduct(parentProduct)
            .then(res => {
              if (res.result !== 1) {
                this.$message({
                  type: "error",
                  message: res.message ? res.message : "编辑失败",
                });
                return;
              }
              this.$message({
                type: "success",
                message: "更新成功!",
              });
              this.getData();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    getPurchaseColorLabel(productType, productColor) {
      let purchases = this.allPurchases.filter(pd => pd.productType == productType && productColor == pd.productColor);
      let colorSet = new Set();
      purchases.forEach(pd => colorSet.add(pd.purchaseColorName));
      return [...colorSet].join(",");
    },
    getParentPurchaseColorLabel(productType, productColor) {
      let parentProduct = this.productList.find(pd => pd.productType == productType);
      console.log(parentProduct.purchaseColors);
      let purchaseColors = parentProduct.purchaseColors ? JSON.parse(parentProduct.purchaseColors) : [];
      let colorObj = purchaseColors.find(pc => pc.productColor == productColor);
      return colorObj ? colorObj.purchaseColorName : "";
    },
    voidOutStockPlan(row) {
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.addOrUpdateOutStockPlan({ id: row.id, status: -1 }).then(res => {
          this.getData();
        });
      });
    },
    getData() {
      requestModules.fetchOutStockPlans(this.params).then(res => {
        this.planList = res.ldata;
      });
    },
    getStatusLabel(row) {
      let label = "";
      row.status == 1 && (label = "出库中");
      row.status == -1 && (label = "已作废");
      row.status == 2 && (label = "出库完成");
      return label;
    },
    getColorLabel(key) {
      let color = colors.find(color => color.key == key);
      let label = "";
      color && (label = color.name);
      return label;
    },
  },
  computed: {
    dataList() {
      let list = [];
      this.productList.forEach(pd => {
        let colorList = Array.isArray(pd.checkColors) ? pd.checkColors : JSON.parse(pd.checkColors);
        let data = {
          ...pd,
          colorList,
        };
        list.push(data);
      });
      list.sort((a, b) => b.productType - a.productType);
      return list;
    },
  },
};
</script>

<style lang="scss">
#ProductPurchaseColorMgmt {
  .breadcrumb-box {
    .el-breadcrumb {
      margin: 20px 0px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .main-box {
    background-color: white;
    padding: 20px;
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
    .greenText {
      color: red;
    }
    .greenYellowText {
      color: rgb(233, 104, 104);
    }
    .yellowText {
      color: rgb(112, 56, 56);
    }

    .line-two {
      height: 20px;
      line-height: 20px;
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
